const CURRENCY = "PKR";
const FIRED_KEY = "rd_ttq_purchases";

const ttq = () => (typeof window !== "undefined" ? window.ttq : null);

const send = (event, params, eventId) => {
    try {
        const t = ttq();
        if (!t) return;
        if (eventId) t.track(event, params, { event_id: eventId });
        else t.track(event, params);
    } catch {
        /* never break the storefront */
    }
};

const contentsFor = (product, bundle) => {
    const qty = Math.max(1, Number(bundle?.quantity) || 1);
    const total = Number(bundle?.price) || 0;
    return {
        contents: [
            {
                content_id: product?.slug,
                content_type: "product",
                content_name: product?.name,
                quantity: qty,
                price: Math.round(total / qty),
            },
        ],
        content_type: "product",
        value: total,
        currency: CURRENCY,
    };
};

const sha256 = async (value) => {
    const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(value));
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
};

const toE164 = (phone) => {
    const digits = (phone || "").replace(/\D/g, "");
    if (!digits) return "";
    return `+92${digits.replace(/^92/, "").replace(/^0/, "")}`;
};

export async function ttIdentify({ email, phone }) {
    try {
        const t = ttq();
        if (!t || !window.crypto?.subtle) return;
        const payload = {};
        const e = (email || "").trim().toLowerCase();
        const p = toE164(phone);
        if (e) payload.email = await sha256(e);
        if (p) payload.phone_number = await sha256(p);
        if (Object.keys(payload).length) t.identify(payload);
    } catch {
        /* ignore */
    }
}

export const ttPage = () => {
    try {
        ttq()?.page();
    } catch {
        /* ignore */
    }
};

export const ttViewContent = (product) => {
    if (!product?.bundles?.length) return;
    send("ViewContent", contentsFor(product, product.bundles[0]));
};

export const ttAddToCart = (product, bundle) => {
    if (!product || !bundle) return;
    send("AddToCart", contentsFor(product, bundle));
};

export const ttInitiateCheckout = (product, bundle) => {
    if (!product || !bundle) return;
    send("InitiateCheckout", contentsFor(product, bundle));
};

const firedOrders = () => {
    try {
        return JSON.parse(localStorage.getItem(FIRED_KEY) || "[]");
    } catch {
        return [];
    }
};

export async function ttCompletePayment(order, { email, phone } = {}) {
    if (!order?.order_number || !order?.total_price) return;
    const fired = firedOrders();
    if (fired.includes(order.order_number)) return;
    try {
        localStorage.setItem(FIRED_KEY, JSON.stringify([...fired, order.order_number].slice(-50)));
    } catch {
        /* ignore */
    }
    await ttIdentify({ email, phone });
    const qty = Math.max(1, Number(order.bundle_quantity) || 1);
    send(
        "CompletePayment",
        {
            contents: [
                {
                    content_id: order.product_slug,
                    content_type: "product",
                    content_name: order.product_name,
                    quantity: qty,
                    price: Math.round((Number(order.subtotal) || Number(order.total_price)) / qty),
                },
            ],
            content_type: "product",
            value: Number(order.total_price),
            currency: CURRENCY,
            order_id: order.order_number,
        },
        order.order_number,
    );
}
